'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const OvertimeIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="OvertimeIcon">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="Hospital-Post-Care-2--Streamline-Ultimate" height="24" width="24">
        <desc>
          Hospital Post Care 2 Streamline Icon: https://streamlinehq.com
        </desc>
        <defs></defs>
        <title>hospital-post-care-2</title>
        <path d="M21.313 11.018a10.486 10.486 0 1 1 -8.376 -8.34" fill="none" stroke="#3d517b8f" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"></path>
        <path d="m11.001 7.5 0 5.5 -3.387 3.999" fill="none" stroke="#3d517b8f" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"></path>
        <path d="M23.5 4a0.5 0.5 0 0 0 -0.5 -0.5h-2.5V1a0.5 0.5 0 0 0 -0.5 -0.5h-2a0.5 0.5 0 0 0 -0.5 0.5v2.5H15a0.5 0.5 0 0 0 -0.5 0.5v2a0.5 0.5 0 0 0 0.5 0.5h2.5V9a0.5 0.5 0 0 0 0.5 0.5h2a0.5 0.5 0 0 0 0.5 -0.5V6.5H23a0.5 0.5 0 0 0 0.5 -0.5Z" fill="none" stroke="#3d517b8f" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"></path>
      </svg>
    </SvgIcon>
  )
}

OvertimeIcon.propTypes = {
  sx: PropTypes.object
}
